import { useState } from 'react';
import type { ReactNode } from 'react';
import Icon from '@/components/Icon/Icon';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';
import { HStack } from '../Layout';
type ToggleHelpTextProps = {
  title: string;
  className?: string;
  children: ReactNode;
  defaultOpen?: boolean;
};
export function ToggleHelpText({
  title,
  className,
  children,
  defaultOpen = false
}: ToggleHelpTextProps) {
  const [open, setOpen] = useState(defaultOpen);
  const handleToggle = () => {
    setOpen(!open);
  };
  return <Button variant="ghost" className={cn('relative block h-auto w-full justify-start overflow-visible whitespace-normal hover:bg-transparent', className)} onClick={handleToggle}>
      <HStack className={cn('items-start justify-start')}>
        <Icon iconName="ChevronDownIcon" className={cn('mx-[10px] mt-0.5 transition-transform', open ? '' : '-rotate-90')} />
        <div className="mt-0">{open ? children : title}</div>
      </HStack>
    </Button>;
}